import React, { useContext, useEffect, useRef, useState } from 'react'
import ProfessionalDetailsModal from '../../../../Modals/ProfessionalDetailsModal';
import RevertApproval from './RevertApproval';
import { Context } from 'Context/Context';
import { casesStatusUpdateApi, DEFAULTAVATAR, denyToViewApi, raiseNotificationApi } from 'Constants';
import { getCaseType } from 'Utils';
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { IoIosExpand } from "react-icons/io";
import { HiUserGroup } from "react-icons/hi2";

import { IoIosRemoveCircleOutline } from "react-icons/io";
import { MdGroups } from 'react-icons/md';
import AreYouSureModal from 'Modals/AreYouSureModal';
import { FaSackDollar } from 'react-icons/fa6';
import { View, ChevronRight } from 'lucide-react';
import useIsMobile from 'Hooks/useIsMobile';


function StepperContentList({contentStep, caseDetails, setUpdateComp, requestPopupRef}) {
   
  const [showModalProf, setShowModalProf] = useState(false);
  const isMobile = useIsMobile();
  const [startIndex, setStartIndex] = useState(0);
  const [approveDetail, setApproveDetail] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const {makeApiCallFunc} = useContext(Context);
  const [professionalDetails, setProfessionalDetails] = useState([]);

  // Case/state preference shown as two pill tags (matching the pre-approve
  // card design) instead of plain table columns.
  const getPreferenceTags = (userObj) => {
    const casePrefLabel = userObj?.casePref?.filter((i) => i === caseDetails?.caseType).length
        ? getCaseType(userObj?.casePref?.filter((i) => i === caseDetails?.caseType)?.[0])
        : "All case types";
    const statePrefLabel = userObj?.statePref?.filter((i) => i === caseDetails?.caseState).length
        ? userObj?.statePref?.filter((i) => i === caseDetails?.caseState)
        : "All states";
    return [casePrefLabel, statePrefLabel];
  }

  const onApprove = (detail) => {
    const currentDetail = detail ? detail : approveDetail;
    if(showModalProf ) {
      setShowModalProf(false);
    }
    if(currentDetail)
    {
        const postData = {
            caseId: caseDetails?._id,
            "userId" : currentDetail?.userId?._id,
            "assistantId" : currentDetail?.assistantId?._id,
            caseStatus: "approved",
        }
        makeApiCallFunc(
            casesStatusUpdateApi,
            postData,
            (data) => {
                
                const notificationObj = {
                    title : "Approved Request - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                    is_read : false,
                    sender: "client",
                    notificationCategory: 1,
                    caseNumber: caseDetails?.caseNumber,
                    type: "3",
                    receiver:  currentDetail?.userId?._id,
                    additionalInfo: {
                        caseId: caseDetails?._id
                    },
                    content: "Your request to view the case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " has been approved by the potential client. Find this case in your approved cases list. You may now proceed to check for conflicts."
                }
                // toast.success("Approved to view");
                setUpdateComp(prev => !prev);
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                    (data) => console.log(data),
                    (error) => console.log(error)
                    )
            },
            (data) => {
                
            
                console.log(data)
            }
        )
    }
    else
    {
        console.log("No approve detail found");
        alert("Please try again");
    }
    }
    const onDeny = (attorney) => {
    setShowModalProf(false);
    
    
    const postData = {
        caseId: caseDetails?._id,
        "userId" : attorney?.userId?._id,
        "assistantId" : attorney?.assistantId?._id,
        caseStatus: "denied"
    }
    makeApiCallFunc(
        denyToViewApi,
        postData,
        (data) => {
            setUpdateComp(prev => !prev);
            const notificationObj = {
                title : "Denied Request - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                notificationCategory: 1,
                caseNumber: caseDetails?.caseNumber,
                is_read : false,
                sender: "client",
                type: "4",
                additionalInfo: {
                    caseId: caseDetails?._id
                },
                receiver:  attorney?.userId?._id,
                content: "Your request to view the case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " has been denied by the potential client. However, you may request to view this case again from the list of all cases, if you continue to remain interested in this case." 
            }
            // toast.success("Denied the professional from viewing the case");
            makeApiCallFunc(raiseNotificationApi, 
                notificationObj, 
                (data) => console.log(data),
                (error) => console.log(error)
                );
        },
        (data) => {
    
        
            console.log(data)
        }
    )
    }
      
  useEffect(() => {
    setProfessionalDetails(getData());
    // setProfessionalDetails((prev) => prev.filter((item) => item?.userId?._id !== undefined));
  },[contentStep, caseDetails]);
 
  const getData = () =>{

    switch(contentStep) {
        case 2:
            return caseDetails?.userCase?.["requested"];
        case 3:
            return caseDetails?.userCase?.["approved"];
        case 4:
            return caseDetails?.userCase?.["noConflict"];
        case 5:
            return caseDetails?.userCase?.["reqToClose"];
        default: 
        return {};
  }
}
  const onClose = () => {
        setStartIndex(0)
        setShowModalProf(false)
  }
  const title = () => {
    switch(contentStep) {
        case 2:
            return "New requests to view this case";
        case 3:
            return <>Approved, awaiting conflict clearance</>;
        case 4:
            return "Conflict cleared, review in progress..";
        case 5:
            return "Request to close case";
        default: 
        return "Tile goes here";
  }}
  return (
    <>
    {
        showModalProf &&
        <ProfessionalDetailsModal
        showModalProf={showModalProf}
        setShowModalProf={setShowModalProf}
        setUpdateComp={setUpdateComp}
        caseDetails={caseDetails}
        contentStep={contentStep}
        onClose={onClose}
        professionalDetails = {professionalDetails}
        startIndex={startIndex}
        />
    }
    {
        showConfirmPopup &&
        <AreYouSureModal
            onClose={() => setShowConfirmPopup(false)}
            uploadNew={showConfirmPopup}
            text = "Please note that this request was submitted by a Litigation Funder and not an Attorney."
            onSubmit={() => {
                setShowConfirmPopup(false);
                onApprove();
            }}
            buttonName='Approve Request'
            onCancel={() => setShowConfirmPopup(false)}
        />
    }
        <div className={'rounded w-full lg:px-10 ' + (isMobile ? 'px-4 pt-3 pb-4 bg-cream' : 'bg-white')} ref={requestPopupRef}>
            <div className=' hidden lg:flex justify-between items-center '>
                <div className='text-gray-600 mb-4 mt-6 font-bold lg:text-base text-xs'>
                   {title()}
                </div>
                
             </div>
             <div className={isMobile ? "" : "max-h-80 overflow-y-auto"}>
                <div className='flex w-full flex-col gap-2.5'>
                {professionalDetails?.length > 0 ? (
                  professionalDetails.map((detail, key) => {
                    if (detail?.userId?._id === undefined) {
                      return (
                        <div key={key} className='text-center text-[13px] font-semibold text-navy bg-[rgba(20,33,61,.04)] rounded-[10px] p-4'>
                          User has either deleted the account or changed firm details, so they are not found.
                        </div>
                      );
                    }
                    const [casePrefTag, statePrefTag] = getPreferenceTags(detail?.userId);
                    const approveClick = () => {
                        setApproveDetail(detail);
                        if(detail?.userId?.isUserFunder === true) setShowConfirmPopup(true);
                        else onApprove(detail);
                    };
                    if (isMobile) {
                      // Mobile: name + firm on top, full-width actions underneath.
                      // Preferences and everything else are one tap away (card opens the details).
                      return (
                        <div
                        key={key}
                        role="button"
                        tabIndex={0}
                        onClick={() => { setStartIndex(key); setShowModalProf(true); }}
                        className='border border-[rgba(20,33,61,.12)] rounded-[10px] p-3.5 bg-white font-plexsans'
                        >
                          <div className='flex items-center gap-3 min-w-0'>
                            {detail?.userId?.isUserFunder ? (
                              <div className='w-10 h-10 rounded-full bg-[rgba(20,33,61,.05)] flex items-center justify-center flex-none text-tan'>
                                <FaSackDollar className='w-4 h-4' />
                              </div>
                            ) : (
                              <img className='w-10 h-10 rounded-full object-cover flex-none bg-[rgba(20,33,61,.05)]' src={detail?.userId?.profilePic ? detail?.userId?.profilePic : DEFAULTAVATAR} alt="" />
                            )}
                            <div className='min-w-0 flex-1'>
                              <div className='text-[14.5px] font-semibold text-navy truncate'>{detail?.userId?.firstName} {detail?.userId?.lastName}</div>
                              <div className='text-[12px] text-[rgba(20,33,61,.5)] truncate'>
                                {detail?.userId?.isUserFunder ? 'Litigation funder' : (detail?.userId?.company || detail?.userId?.legalType || 'Attorney')}
                              </div>
                            </div>
                            <span className='text-[12px] font-medium text-tan flex-none'>View</span>
                          </div>
                          <div className='mt-3' onClick={(e) => e.stopPropagation()}>
                            {contentStep === 2 ? (
                              <div className='grid grid-cols-2 gap-2'>
                                <button type="button" onClick={approveClick} className='flex items-center justify-center gap-1.5 rounded-lg bg-tan text-white py-2.5 text-[13.5px] font-semibold active:bg-tanDark'>
                                  <IoCheckmarkCircleOutline size={15}/> Approve
                                </button>
                                <button type="button" onClick={() => onDeny(detail)} className='flex items-center justify-center gap-1.5 rounded-lg border border-[rgba(154,59,46,.45)] text-[#9a3b2e] bg-white py-2.5 text-[13.5px] font-semibold'>
                                  <RxCrossCircled size={15}/> Deny
                                </button>
                              </div>
                            ) : (
                              <RevertApproval
                              userId={detail?.userId?._id}
                              caseId={caseDetails?._id}
                              caseType={caseDetails?.caseType}
                              setUpdateComp={setUpdateComp}
                              caseNumber={caseDetails?.caseNumber}
                              />
                            )}
                          </div>
                        </div>
                      );
                    }
                    return (
                      <div
                      key={key}
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                          setStartIndex(key);
                          setShowModalProf(true);
                      }}
                      onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                              setStartIndex(key);
                              setShowModalProf(true);
                          }
                      }}
                      className='group flex items-center justify-between gap-3 border border-[rgba(20,33,61,.12)] rounded-[10px] p-3.5 bg-ivory cursor-pointer hover:border-[rgba(154,59,46,.35)] hover:shadow-[0_2px_10px_rgba(20,33,61,.08)] transition-all flex-wrap'
                      >
                        <div className='flex items-center gap-3 min-w-0'>
                            {detail?.userId?.isUserFunder ? (
                            <div className='w-11 h-11 rounded-full bg-[rgba(20,33,61,.05)] flex items-center justify-center flex-none text-tan'>
                                <FaSackDollar className='w-5 h-5' />
                            </div>
                            ) : (
                            <img
                            className='w-11 h-11 rounded-full object-cover flex-none bg-[rgba(20,33,61,.05)]'
                            src={detail?.userId?.profilePic ? detail?.userId?.profilePic : DEFAULTAVATAR}
                            alt=""
                            />
                            )}
                            <div className='min-w-0'>
                                <div className='text-[14px] font-semibold text-navy truncate'>
                                    {detail?.userId?.firstName} {detail?.userId?.lastName}
                                </div>
                                <div className='text-[12px] text-[rgba(20,33,61,.5)] truncate capitalize'>
                                    {detail?.userId?.legalType}{detail?.userId?.company ? ` · ${detail.userId.company}` : ""}
                                </div>
                                <div className='flex items-center gap-1.5 mt-1.5 flex-wrap'>
                                    <span className='text-[10.5px] font-medium text-tan bg-[rgba(138,98,49,.08)] rounded-full px-2 py-[3px] whitespace-nowrap'>{casePrefTag}</span>
                                    <span className='text-[10.5px] font-medium text-tan bg-[rgba(138,98,49,.08)] rounded-full px-2 py-[3px] whitespace-nowrap'>{statePrefTag}</span>
                                </div>
                            </div>
                        </div>
                        <div className='flex items-center gap-2 flex-none' onClick={(e) => e.stopPropagation()}>
                            {contentStep === 2 && (
                            <>
                                <button
                                type="button"
                                className='flex items-center gap-1.5 rounded-lg bg-tan text-white px-3.5 py-2 text-[13px] font-semibold hover:bg-tanDark transition-colors whitespace-nowrap'
                                onClick={() => {
                                    setApproveDetail(detail);
                                    if(detail?.userId?.isUserFunder === true)
                                    {
                                        setShowConfirmPopup(true);
                                    }
                                    else
                                    {
                                       onApprove(detail);
                                    }
                                }}
                                >
                                    <IoCheckmarkCircleOutline size={14}/>
                                    {isMobile ? "Approve" : "Approve Request"}
                                </button>
                                <button
                                type="button"
                                className='flex items-center gap-1.5 rounded-lg border border-red-600 text-red-600 px-3.5 py-2 text-[13px] font-semibold hover:bg-red-50 transition-colors whitespace-nowrap'
                                onClick={() => onDeny(detail)}
                                >
                                    <RxCrossCircled size={14}/>
                                    {isMobile ? "Deny" : "Deny Request"}
                                </button>
                            </>
                            )}
                            {contentStep !== 2 && (
                                <RevertApproval
                                userId={detail?.userId?._id}
                                caseId={caseDetails?._id}
                                caseType={caseDetails?.caseType}
                                setUpdateComp={setUpdateComp}
                                caseNumber={caseDetails?.caseNumber}
                                />
                            )}
                            <ChevronRight size={16} className='text-[rgba(20,33,61,.3)] group-hover:text-[rgba(154,59,46,.6)] transition-colors flex-none' />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='text-center text-[13px] text-[rgba(20,33,61,.5)] bg-[rgba(20,33,61,.04)] rounded-[10px] p-4'>
                    No new request
                  </div>
                )}
                </div>
{(professionalDetails?.length && !isMobile ?
                <div className='flex justify-center items-center lg:mt-4 my-2 text-xs lg:text-sm lg:mb-10'>
                <div className=' p-2 rounded w-max text-gray-800 underline cursor-pointer ' onClick={() => setShowModalProf(true)}
                
                >Show All Details</div></div> : '')}
                </div>
        </div>
        
        
    </>
  )
}

export default StepperContentList;